import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomConfirmDialogService } from 'src/app/services/Non-Master/CustomConfirmDialog.service';
import { LoggerService } from 'src/app/services/Non-Master/logger.service';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { MastersKeyStringValue } from 'src/app/services/Non-Master/MastersKeyStringValue.service';
import { AppSettings } from 'src/app/shared/AppSettings';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SystemDefaultModel, ChineseDefaultModel, EnglishDefaultModel } from 'src/app/models/non-master-model/SystemDefaultModel';
import { AppComponent } from 'src/app/app.component';
import { FormControl } from '@angular/forms';

import { tBedService } from 'src/app/services/tBed.service';
import { tBedModel } from 'src/app/models/tBedModel';
import { NavigationComponent } from 'src/app/pages/navigation/navigation.component';

import { DateTimeConvertService } from 'src/app/services/CommonService/DateTimeConvert.service';



@Component({
  selector: 'app-select-bed-no-dialog',
  templateUrl: './select-bed-no-dialog.component.html',
  styleUrls: ['./select-bed-no-dialog.component.css']
})
export class SelectBedNoDialogComponent implements OnInit {

  selectedRowIndex: number = -1;

  constructor(public activeModal: NgbActiveModal,
    private log: LoggerService,
    private tBedService: tBedService,
    private DateTimeConvertService: DateTimeConvertService) { }

  displayedColumns: string[] = [
    // 'action_button_title',
    // 'shopID',
    // 'bedID',
    // 'shopBldgID',

    'bedDesc',
    // 'bedTel',
    // 'bedFax',
    'bedRemark',
    // 'lastModifyDatetime',
    // 'lastModifyUserID',
    // 'isActive'

  ];

  dataSource: MatTableDataSource<tBedModel>;
  dataList: tBedModel[];
  private TAG = 'SelectBedNoDialogComponent';
  action_delete = MastersKeyStringValue.ACTION_DELETE;
  tableKeyValue = MastersKeyStringValue.TABLE_Bed;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  bedDescFilter = new FormControl();

  filteredValues = {
    bedDesc: ''
  };


  @Input() clthConsultNumber: string;


  ngOnInit() {
    this.getAllData();
  }

  getAllData(): void {
    let dbToday = this.DateTimeConvertService.ConvertCurrentDBDay(new Date()).toString();

    this.tBedService.getAllDataByShopID(NavigationComponent.selectedShopID.toString(), dbToday, this.clthConsultNumber).subscribe(data => {

      this.dataList = data;
      this.dataSource = new MatTableDataSource<tBedModel>(data);
      this.dataSource.paginator = this.paginator;

      this.bedDescFilter.valueChanges.subscribe((value) => {
        this.filteredValues['bedDesc'] = value;
        this.dataSource.filter = JSON.stringify(this.filteredValues);
      });

      this.dataSource.filterPredicate = this.customFilterPredicate();
      //table sort
      this.dataSource.sort = this.sort;

    });
  }

  customFilterPredicate() {
    const myFilterPredicate = (data: tBedModel, filter: string): boolean => {

      const searchString = JSON.parse(filter);

      return (searchString.bedDesc.toLowerCase() === '' ||
        (data.bedDesc != null && data.bedDesc.toString().trim().toLowerCase().indexOf(searchString.bedDesc.toLowerCase()) !== -1))
        ;
    }
    return myFilterPredicate;
  }


  selectRow(selectedModel: tBedModel, index: number) {

    this.log.i(this.TAG, 'selectRow');


    this.activeModal.close(selectedModel);
  }

}
